import React from 'react';
import connectToStores from 'fluxible-addons-react/connectToStores';
import shallowCompare from '../../lib/shallowCompare';
import StoreStore from '../../stores/StoreStore';
import StoreFeedLayout from '../../components/StoreFeedLayout';
import styles from '../BaseContainer/index.sass';

class StoreFeedContainer extends React.Component {
  shouldComponentUpdate(nextProps, nextState) {
    return shallowCompare(this, nextProps, nextState);
  }

  renderJSONLD(store) {
    let jsonLD = {
      "@context": "http://schema.org",
      "@type": "Organization",
      "email": store.contact_email,
      "telephone": store.phone_pretty,
      "url": store.url
    };
    if(store.background_photo_hash) {
      jsonLD.image = store.background_photo_hash.url;
    }
    if(store.logo_photo_hash) {
      jsonLD.logo = store.logo_photo_hash.url;
    }
    let address = store.address;
    if(address) {
      jsonLD.address = {
        "@type": "PostalAddress",
        "addressLocality": `${address.city}, ${address.state}, United States`,
        "postalCode": address.zip_code,
        "streetAddress": `${address.addr1}`
      };
      if(address.addr2) {
        jsonLD.address.streetAddress += ` ${address.addr2}`;
      }
    }
    return <script type="application/ld+json" dangerouslySetInnerHTML={{__html: JSON.stringify(jsonLD)}} />;
  }

  render() {
    let { store, storeFeed, shoppingCart, customer } = this.props;
    let storeLandingPageProps = {
      store,
      storeFeed,
      shoppingCart,
      customer
    };

    return (
      <section className={styles.container}>
        <StoreFeedLayout {...storeLandingPageProps} />
        {this.renderJSONLD(store)}
      </section>
    );
  }
}

StoreFeedContainer = connectToStores(StoreFeedContainer, [StoreStore], (context, props) => {
  return {
    storeFeed: context.getStore(StoreStore).getFeedBySlug(props.store.slug)
  };
});

export default StoreFeedContainer;



// WEBPACK FOOTER //
// banquet/containers/StoreFeedContainer/index.js